import { FC } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import S from "./index.module.scss";

interface ICloseButton {
  onClose(): void;
}

const CloseButton: FC<ICloseButton> = ({ onClose }) => {
  return (
    <button className={S.button} onClick={onClose}>
      <CustomIcon fileName="icon-close-large" />
    </button>
  );
};

export default CloseButton;
